// Enum of possible action types
export enum GiftcardCustomAmountReducerActionTypes {
  CUSTOM_AMOUNT_UPDATE = 'CUSTOM_AMOUNT_UPDATE',
}

export interface GiftcardCustomAmountReducerAction {
  type: GiftcardCustomAmountReducerActionTypes;
  payload: number | undefined;
}

export type GiftcardCustomAmountReducerState = number | undefined;

export const giftcardCustomAmountReducerInitialState: GiftcardCustomAmountReducerState =
  undefined;

const giftcardCustomAmountReducer = (
  state: GiftcardCustomAmountReducerState,
  action: GiftcardCustomAmountReducerAction
) => {
  switch (action.type) {
    case GiftcardCustomAmountReducerActionTypes.CUSTOM_AMOUNT_UPDATE: {
      return action.payload;
    }
    default: {
      return state;
    }
  }
};

export default giftcardCustomAmountReducer;
